import { create } from 'zustand';
import api from '../lib/api';

const TOKEN_KEY = 'ee_user_token';
const USER_KEY = 'ee_user';

const loadInitial = () => {
  try {
    const u = localStorage.getItem(USER_KEY);
    return u ? JSON.parse(u) : null;
  } catch { return null; }
};

export const useAuthStore = create((set, get) => ({
  user: loadInitial(),
  token: localStorage.getItem(TOKEN_KEY) || null,
  loading: false,
  error: null,

  setUser: (user) => {
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
    else localStorage.removeItem(USER_KEY);
    set({ user });
  },

  setToken: (token) => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
    set({ token });
  },

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const { data } = await api.post('/api/auth/login', { email, password });
      const { token, ...user } = data;
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(USER_KEY, JSON.stringify(user));
      set({ user, token, loading: false });
      return user;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  register: async (email, password, name) => {
    set({ loading: true, error: null });
    try {
      const { data } = await api.post('/api/auth/register', { email, password, name });
      const { token, ...user } = data;
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(USER_KEY, JSON.stringify(user));
      set({ user, token, loading: false });
      return user;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  refreshMe: async () => {
    try {
      const { data } = await api.get('/api/auth/me');
      localStorage.setItem(USER_KEY, JSON.stringify(data));
      set({ user: data });
      return data;
    } catch (e) { return null; }
  },

  updateAvatar: async (avatar) => {
    const { data } = await api.put('/api/auth/avatar', { avatar });
    const u = { ...get().user, selected_avatar: avatar };
    localStorage.setItem(USER_KEY, JSON.stringify(u));
    set({ user: u });
    return data;
  },

  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    set({ user: null, token: null });
  },
}));
